export const STORE_TERRITORY_FAILED = 'store_territory_failed';
export const STORE_TERRITORY_PENDING = 'store_territory_pending';
export const STORE_TERRITORY_LOADED = 'store_territory_loaded';
